export default __webpack_public_path__ + "static/media/smartphone.308f02fe.svg";